import * as Api from '@/utils/request'

let baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL2 = 'https://u.tianxiatongniu.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL2 = 'https://u.tianxiatongniu.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL2 = 'https://u.tianxiatongniu.com';
}

export default {

    //
    async BasicRank(keyword) {
        return await Api.get({
            url: baseURL2+'/applet/api/BasicRank',
            params: {keyword}
        })
    },


}